import { Api } from 'models/services/api';
import { UpdateSatelliteKitchenQuery } from 'models/services/graphql';

import { SatelliteKitchenData, SatelliteKitchenDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: SatelliteKitchenDataToSave;
};

const RequestQuery = `
  mutation UpdateSatelliteKitchen($id: ID!, $input: SatelliteKitchenInput!) {
    ${UpdateSatelliteKitchenQuery}
  }
`;

type ResponseData = {
  data: {
    updateSatelliteKitchen: SatelliteKitchenData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: SatelliteKitchenData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateSatelliteKitchen;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };